/** Conversion-page SEO content (/convert/<pair> and the /convert hub), localized. */

import { useLocale } from "@/hooks/use-locale";
import {
  getConvertSeo, localizeConvert, localizeConvertHub, buildConvertSchema, CONVERT_HUB, type Locale,
} from "@/seo/seo.config";
import SeoArticle from "./SeoArticle";

/** slug: a conversion pair like "shp-to-kml", or "hub" for /convert. */
const ConvertSeoContent = ({ slug }: { slug: string }) => {
  const { locale } = useLocale();
  const loc = locale as Locale;

  if (slug === "hub") {
    const c = localizeConvertHub(loc);
    return <SeoArticle {...c} locale={loc} schema={buildConvertSchema(c, CONVERT_HUB.slug)} />;
  }

  const seo = getConvertSeo(slug);
  if (!seo) return null;
  const c = localizeConvert(seo, loc);
  return <SeoArticle {...c} locale={loc} schema={buildConvertSchema(c, seo.slug)} />;
};

export default ConvertSeoContent;
